import type { TBlockContent } from '@portals/hc-rich-editor';

type TProps = {
  parents: Array<HTMLElement>;
  blockType: TBlockContent;
};
export const getIsTypeOfBlock = ({ parents, blockType }: TProps): boolean => {
  return parents.some((parent) => {
    const classListArray = [...parent.classList];

    return classListArray.some((className) =>
      className.toLowerCase().includes(blockType),
    );
  });
};
